import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NbDialogService, NbToastrService} from '@nebular/theme';
import { MainService } from "../../../services/main.service";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {LocalDataSource} from 'ng2-smart-table';
@Component({
  selector: 'app-crear',
  templateUrl: './crear.component.html',
  styleUrls: ['./crear.component.scss']
})
export class CrearComponent implements OnInit {


  /*  Para el modal */
  @ViewChild('dialog', {static: true}) dialog: ElementRef;
  spinerEdit = false;
  frmFormulario: FormGroup;
  submitted = false;
  
  loading = false;
  loadingPrincipal= false;
  /*****/
  settings = {
    hideSubHeader: true,
    actions: {
      delete: false,
      edit: false,
      add: false,
      filter: false,
      custom: [
        {name: 'edit', title: '<i class="nb-compose"></i> ',},
        {name: 'delete', title: '<i class="nb-trash"></i> ',}
      ],
    },
    columns: {
      nombre: {title: 'Nombre'},
      descripcion: {title: 'Descripcion'},
      estado: {title: 'Estado'}
    }
  };

  datos: any[];

  public source: LocalDataSource;
  constructor(private toastrService: NbToastrService,
    public router: Router,
    private dialogService: NbDialogService,
    public mainService: MainService,
    private rutaActiva: ActivatedRoute,
    public fb: FormBuilder) {
    this.frmFormulario = this.fb.group({
      nombre: [''],
      descripcion: [''],
      estado: ['']
  });
  this.getFormularios();
  }

  ngOnInit() {
  }
  get valoresCrear() {
    return this.frmFormulario.controls;
  }
  getFormularios() {
    this.loadingPrincipal = true;       
    this.mainService.get("newFormulario").subscribe(result => {
      if (result) {
        console.log(result);
        this.datos = result;
        this.source = new LocalDataSource(this.datos);
        this.loadingPrincipal = false;       
      } else {
        console.log("Error al insertar en Sql");
      }
    });
  }
  /** Para modal **/

  crear() {
    this.openDialogSave(this.dialog);
  }

  openDialogSave(dialog) {
    this.dialogService.open(dialog, { context: 'this is some additional data passed to dialog' });
  }

  accion() {
    this.spinerEdit = true;
    const TIME_IN_MS = 3000;
    setTimeout(() => {
      this.spinerEdit = false;
      this.showToast('top-right', 'success', 'Éxito!', 'Se ejecuto éxito!');
      const element: HTMLElement = document.getElementById('btn-close') as HTMLElement;
      element.click();
    }, TIME_IN_MS);
  }

  /** Toas **/
  showToast(position, status, titulo, mensaje) {
    this.toastrService.show(
      mensaje,
      titulo,
      { position, status });
  }
  onCustom(event) {
    console.log(event);
    switch (event.action) {
        case 'edit':
            this.verFormulario(event.data.idp);
            break;
        case 'delete':
            this.loading = true;
            this.eliminar(event.data);
            break;
  
    }
  }
  verFormulario(id) {
    this.router.navigate(['dashboard/editFormulario', id]);
}
eliminar(data) {         
  this.mainService.delete('newFormulario/'+ data.idp).subscribe(result => {
      console.log(result);
      if (result.deleted) {
        this.getFormularios();
          console.log('Se ha eliminado');
          this.loading = false;       
          this.showToast('top-right', 'success', 'Éxito!', 'Borrado exitosamente');

      } else {
        this.getFormularios();
          console.log('Error');
          this.loading = false;
          this.showToast('top-right', 'warning', 'Error!', 'Error al borrar!');
      }
  });
   }
   save() {
    this.loading = true;
    this.submitted = true;
    if (this.frmFormulario.invalid) {
        return false;
    }
    //this.spinner.show();
    let insert = {
      nombre: this.frmFormulario.value.nombre,
      descripcion:this.frmFormulario.value.descripcion,
      estado:this.frmFormulario.value.estado,
    }
    console.log(insert);
    this.mainService.post('newFormulario', insert).subscribe(result => {
        console.log(result);
        if (result) {
            console.log('Se ha insertado');
            this.frmFormulario.reset();
            this.submitted = false;
            //this.spinner.hide();
            this.showToast('top-right', 'success', 'Success!', 'It was created successfully!');
            let element: HTMLElement = document.getElementById('btn-close-save') as HTMLElement;
            this.getFormularios();
            this.loading = false;
            element.click();
            return true;

        } else {
            console.log('Error');
            this.frmFormulario.reset();
            this.submitted = false;
            //this.spinner.hide();
            this.loading = false;
            this.showToast('top-right', 'warning', 'Error!', 'Error creating!');
            let element: HTMLElement = document.getElementById('btn-close-save') as HTMLElement;
            element.click();

            return false;
        }
    });
}
}

